/*
 * C Edu Compare (sections/c-edu-compare.liquid).
 * Three slots. Each product is pre-rendered in a <template data-product>; this
 * clones the picked product's parts into its slot. Swap from the column menu,
 * remove with ×, add from the empty slot. A fourth product cannot be added.
 */
(function () {
  if (customElements.get('c-edu-compare')) return;

  var MAX = 3;

  class CEduCompare extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      var self = this;
      this.table = this.querySelector('.c-cmp');
      this.emptyHead = this.querySelector('template[data-empty-head]');
      this.templates = {};
      this.order = [];
      Array.prototype.forEach.call(this.querySelectorAll('template[data-product]'), function (t) {
        self.templates[t.dataset.product] = t;
        self.order.push(t.dataset.product);
      });

      var defaults = (this.dataset.default || '')
        .split(',')
        .map(function (h) {
          return h.trim();
        })
        .filter(function (h) {
          return self.templates[h];
        });
      if (!defaults.length) defaults = this.order.slice(0, 2);
      this.slots = defaults.slice(0, MAX);

      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('click', this.onClick.bind(this));
      this.render();
    }

    title(handle) {
      return this.templates[handle] ? this.templates[handle].dataset.title : handle;
    }

    fillSelect(select, current) {
      var self = this;
      select.innerHTML = '';
      if (!current) {
        var ph = document.createElement('option');
        ph.value = '';
        ph.textContent = '';
        ph.hidden = true;
        ph.selected = true;
        select.appendChild(ph);
      }
      this.order.forEach(function (handle) {
        var opt = document.createElement('option');
        opt.value = handle;
        opt.textContent = self.title(handle);
        if (handle === current) opt.selected = true;
        else if (self.slots.indexOf(handle) > -1) opt.disabled = true;
        select.appendChild(opt);
      });
    }

    render() {
      var self = this;
      var filled = this.slots.length;
      var firstEmpty = filled < MAX ? filled : -1;

      Array.prototype.forEach.call(this.table.querySelectorAll('.c-cmp__cell[data-slot]'), function (cell) {
        var slot = parseInt(cell.dataset.slot, 10);
        var part = cell.dataset.part;
        var handle = self.slots[slot];
        cell.innerHTML = '';
        cell.classList.toggle('is-empty', !handle);

        if (handle) {
          var src = self.templates[handle].content.querySelector('[data-part="' + part + '"]');
          if (src) {
            Array.prototype.forEach.call(src.childNodes, function (n) {
              cell.appendChild(n.cloneNode(true));
            });
          }
          if (part === 'head') self.fillSelect(cell.querySelector('.c-cmp__swap'), handle);
          return;
        }

        if (part === 'head') {
          if (slot === firstEmpty) {
            cell.appendChild(self.emptyHead.content.cloneNode(true));
            self.fillSelect(cell.querySelector('.c-cmp__add-select'), null);
          }
          return;
        }

        var dash = document.createElement('span');
        dash.className = 'c-cmp__empty';
        dash.textContent = '—';
        cell.appendChild(dash);
      });

      var full = filled >= MAX;
      this.table.dataset.filled = filled;
      this.table.style.setProperty('--cmp-cols', Math.max(filled, 1));
      this.querySelector('.c-cmp__full-wrap').hidden = !full;
      this.querySelector('.c-cmp__full-mob').hidden = !full;
      var mobSelect = this.querySelector('.c-cmp__add--mob .c-cmp__add-select');
      mobSelect.disabled = full;
      this.fillSelect(mobSelect, null);
    }

    onChange(e) {
      var t = e.target;
      if (t.classList.contains('c-cmp__swap')) {
        var cell = t.closest('[data-slot]');
        this.slots[parseInt(cell.dataset.slot, 10)] = t.value;
        this.render();
        var again = this.querySelector('.c-cmp__head[data-slot="' + cell.dataset.slot + '"] .c-cmp__swap');
        if (again) again.focus();
      } else if (t.classList.contains('c-cmp__add-select')) {
        if (!t.value || this.slots.length >= MAX || this.slots.indexOf(t.value) > -1) return;
        this.slots.push(t.value);
        this.render();
      }
    }

    onClick(e) {
      var btn = e.target.closest('.c-cmp__remove');
      if (!btn) return;
      var cell = btn.closest('[data-slot]');
      this.slots.splice(parseInt(cell.dataset.slot, 10), 1);
      this.render();
      var next = this.querySelector('.c-cmp__head .c-cmp__swap, .c-cmp__head .c-cmp__add-select');
      if (next) next.focus();
    }
  }

  customElements.define('c-edu-compare', CEduCompare);
})();
